import { observer } from 'mobx-react';
import React, {
  SyntheticEvent,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import { useLocation, useParams } from 'react-router-dom';
// import noMessageIcon from '../../assets/Images/filterNodata.png';
import noMessageIcon from '../../../assets/Images/filterNodata.png';
import userSettingEnum from '../../../constants/enums/user-setting-enum';
import { useStore } from '../../../contexts/store-provider';
import {
  PartsSearchDefaultSortColumnOrder,
  PartsSearchFilterInitialState,
  TagFilterDefaultSortColumnOrder,
  TagsFilterInitialState,
} from '../../../core/initialState/filter-initial-state';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import IPageInfo, {
  IMultiSelectOption,
  IPageLimitInfo,
} from '../../../models/ICommon';
import IDefaultColumSortOrder from '../../../models/IDefaultColumSortOrder';
import { ITagsFilter } from '../../../models/ITagsFilter';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Grid from '../../../shared-components/Grid/Grid';
import Pagination from '../../../shared-components/Grid/Pagination';
import FilterPopupHOC from '../../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../../shared-components/popup/delete/delete-popup-hoc';
import { FilterIcon } from '../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../translations/format-message';
import Header from '../../../shared-components/header/header';
import { MultiSelect } from 'react-multi-select-component';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../../helpers/action-permission-helper';
import { ModuleType } from '../../../constants/enums/module-type-enum';
import LEDBlink from '../../dashboards/order-table-view/components/led-blink';
import LEDBlinkPopupHOC from '../../dashboards/order-table-view/hoc/led-blink-popup-hoc';
import {
  bOMGroups,
  IBomGroup,
  IBOMSearchFilter,
  IPartsSearchFilter,
} from '../../../models/IBOMSearchFilter';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';

const PartsSearch = (props: any) => {
  const [scannedItems, setScannedItems] = useState([]);
  const [scannedBarcode, setScannedBarcode] = useState('');
  const { taskId } = useParams<any>();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const processName = queryParams.get('processName');
  const {
    processStore,
    preferencesStore,
    operatorStore,
    bomStore,
    activeTrayManagementStore,
    dashboardStore,
  } = useStore();
  const [tagRemoveRows, setTagRemoveRows] = useState([]);
  const [tagId, setTagId] = useState(''); //remove later
  const [removeTrayId, setRemoveTrayId] = useState(''); //remove later
  const [scannedData, setScannedData] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const {
    ledBlinkState,
    resetLedBlinkState,
    resetGetOrderTableListServiceState,
  } = dashboardStore;

  const {
    SaveProcessOrderService,
    saveProcessOrderState,
    resetSaveProcessOrderState,
  } = activeTrayManagementStore;

  const {
    GetPartsSearchResultsService,
    getPartsSearchResultsServiceState,
    partSearchGridData,
    allDimensionHeaders,
    partsKatashikiList,
    PartsSearchList,
    // dimensionHeaderOptions,
    columnListDetails,
    GetPartsSearchColumnsService,
    getPartsSearchColumnListState,
    visiblePartsSearchColumnsList,
    resetGetPartsSearchResultsServiceState,
  } = bomStore;

  const {
    getFilteredTraysState,
    getAllFilteredTrays,
    resetFilteredTraysList,
    assignTagState,
    GetTrayDetailsOnScan,
    getTrayDetailsOnScanState,
    trayDetailComputed,
    removeTagState,
    resetAssignTagState,
    resetRemoveTagState,
    resetGetTrayDetailsOnScanState,
    filteredTraysList,
    responseData,
  } = operatorStore;

  const {
    userSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
    setUserSetting,
  } = preferencesStore;

  let lang: string;
  const [scanBuffer, setScanBuffer] = useState('');
  const [lastKeyTime, setLastKeyTime] = useState(Date.now());
  const allFilteredTrays = getAllFilteredTrays;
  const [rows, setRows] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState('');
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    PartsSearchDefaultSortColumnOrder
  );
  const [filterObj, setFilterObj] = useState<IPartsSearchFilter>(
    PartsSearchFilterInitialState
  );

  const pageLimitOptions: Array<number> = [10, 20, 50, 100];

  const [fontSizeClass, setFontSizeClass] = useState<string>(
    'opertor-normal-text'
  );
  const [activeSize, setActiveSize] = useState<'small' | 'normal' | 'large'>(
    'normal'
  );

  const [orderViewColumnFields, setOrderViewColumnFields] = useState<
    IMultiSelectOption[]
  >([]);

  const [dimensionColumnFields, setDimensionColumnFields] = useState<
    IMultiSelectOption[]
  >([]);

  const [allowedColumns, setAllowedColumns] = useState(['checkbox']);

  const [selected, setSelected] = useState([]);
  const [selectedDimensions, setSelectedDimensions] = useState([]);
  const [selectedIds, setSelectedIds] = useState<any[]>([]);

  const locationState = location.state as {
    state: IPartsSearchFilter;
    bOMGroups: bOMGroups;
  } | null;
  const groupsFromStorage = JSON.parse(
    localStorage.getItem('selectedRows') || 'null'
  );
  const normalizeBOMGroupsPayload = (payload: any): bOMGroups => {
    if (Array.isArray(payload)) {
      return payload as IBomGroup[];
    }
    if (payload?.BomGroups && Array.isArray(payload.BomGroups)) {
      return payload.BomGroups as IBomGroup[];
    }
    return [];
  };

  const groups = normalizeBOMGroupsPayload(
    locationState?.bOMGroups ?? groupsFromStorage
  );
  const normalizedGroups: IBomGroup[] = groups;
  const filter = locationState?.state;
  const initialKatashikiOptions: IMultiSelectOption[] = useMemo(
    () =>
      Array.from(
        new Set(
          normalizedGroups
            .map((group) => group?.MaterialKatashiki)
            // .filter((katashiki): katashiki is string => !!katashiki)
        )
      ).map((katashiki) => ({
        label: katashiki.trim() === '' ? '--' : katashiki,
        value: katashiki || '',
      })),
    [normalizedGroups]
  );

  const incomingKatashikiKey = useMemo(
    () =>
      initialKatashikiOptions
        .map((opt) => opt.value || '--')
        .sort()
        .join('|'),
    [initialKatashikiOptions]
  );

  const normalizePartsSearchFilter = (
    source?: Partial<IPartsSearchFilter> | null
  ): IPartsSearchFilter => ({
    ...PartsSearchFilterInitialState,
    ...(source ?? {}),
    Column: 'TrayId',
    Order: 'asc',
  });

  const parseStoredPartsSearchFilter = (
    storedFilter: string | null
  ): Partial<IPartsSearchFilter> | null => {
    if (!storedFilter) {
      return null;
    }

    try {
      return JSON.parse(storedFilter) as Partial<IPartsSearchFilter>;
    } catch {
      return null;
    }
  };

  const getFilterObjectFromLocation = (): IPartsSearchFilter => {
    const parsedStoredFilter = parseStoredPartsSearchFilter(
      localStorage.getItem('filter')
    );
    return normalizePartsSearchFilter(filter ?? parsedStoredFilter);
  };

  const handleFontSizeChange = (size: 'small' | 'normal' | 'large') => {
    setActiveSize(size);

    if (size === 'small') {
      setFontSizeClass('opertor-small-text');
    } else if (size === 'large') {
      setFontSizeClass('opertor-text-large');
    } else {
      setFontSizeClass('opertor-normal-text');
    }
  };

  useEffect(() => {
    setRows(partSearchGridData);
  }, [partSearchGridData]);

  useEffect(() => {
    if (getPartsSearchResultsServiceState.success) {
      setRows(partSearchGridData);
      resetGetPartsSearchResultsServiceState();
    }
  }, [getPartsSearchResultsServiceState.success]);

  useEffect(() => {
    localStorage.setItem(
      'materialKatashiki',
      JSON.stringify(incomingKatashikiKey)
    );
    setSelectedIds([])
    GetPartsSearchColumnsService(Number(getTenantIdFromLocalStorage()));
  }, []);

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const getFilteredTraysListServiceHandler = () => {
    const materialKatashiki = selected.map((option) => option.value === '' ? ' ': option.value);
    const normalizedFilter = getFilterObjectFromLocation();
    const activeFilter = {
      ...normalizedFilter,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    };

    setFilterObj(activeFilter);
    localStorage.setItem('filter', JSON.stringify(activeFilter));

    GetPartsSearchResultsService(
      Number(getTenantIdFromLocalStorage()),
      pageInfo.currentPage,
      pageLimitInfo.pageLimit,
      [],
      materialKatashiki,
      true,
      activeFilter,
      groups
    );
  };

  useEffect(() => {
    const normalizedFilter = getFilterObjectFromLocation();

    setFilterObj(normalizedFilter);
    setColumnSortOrder({
      dataField: normalizedFilter.Column,
      order: normalizedFilter.Order,
    });
    localStorage.setItem('filter', JSON.stringify(normalizedFilter));

    setRows([]);
    setSelectedIds([]);
    setSelectedRow({});
    setSelectedId('');
    setOrderViewColumnFields(initialKatashikiOptions);
    setSelected(initialKatashikiOptions);
    GetPartsSearchResultsService(
      Number(getTenantIdFromLocalStorage()),
      1,
      pageLimitInfo.pageLimit,
      [],
      [],
      false,
      normalizedFilter,
      groups
    );
    // resetFilteredTraysList();
  }, [incomingKatashikiKey]);

  useEffect(() => {
    if (initialKatashikiOptions.length > 0) {
      return;
    }

    if (partsKatashikiList?.length > 0) {
      setOrderViewColumnFields(partsKatashikiList);
      setSelected(partsKatashikiList);
    } else {
      setOrderViewColumnFields([]);
      setSelected([]);
    }
  }, [partsKatashikiList, initialKatashikiOptions.length]);

  useEffect(() => {
    if (getPartsSearchColumnListState.success) {
      setDimensionColumnFields([...columnListDetails]);
      setAllowedColumns([...columnListDetails.map((column) => column.value)]);
    }
  }, [getPartsSearchColumnListState.success]);

  useEffect(() => {
    if (visiblePartsSearchColumnsList.length > 0) {
      setSelectedDimensions(visiblePartsSearchColumnsList);
      // setDimensionColumnFields(visiblePartsSearchColumnsList);
      setAllowedColumns([
        ...visiblePartsSearchColumnsList.map((column) => column.value),
      ]);
    }
  }, [visiblePartsSearchColumnsList]);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages: PartsSearchList?.PagingDetails?.TotalPages,
      currentPage: PartsSearchList?.PagingDetails?.CurrentPage,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [PartsSearchList]);

  useEffect(() => {
    if (getFilteredTraysState.error) {
      toast.error(formatMessage(getFilteredTraysState.error));
      resetFilteredTraysList();
    }
  }, [getFilteredTraysState.error]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getFilteredTraysListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getFilteredTraysListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  // useEffect(() => {
  //     if (pageInfo.isPagerChange) {
  //       getProcessListServiceHandler();
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [pageInfo.currentPage]);

  //   useEffect(() => {
  //     if (pageLimitInfo.isPageLimitChange) {
  //       getProcessListServiceHandler();
  //       setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
  //     }
  //   }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getFilteredTraysListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (assignTagState.error) {
      if (responseData === '') {
        toast.error(formatMessage(assignTagState.error));
      } else {
        const [beforeHash, afterHash] = responseData.split('#');
        if (beforeHash.length === 0 && afterHash.length === 0) {
          toast.error(formatMessage('could_not_connect_to_AIMS_server'));
        } else {
          toast.error(
            `${formatMessage(assignTagState.error)} ${
              beforeHash.length > 0
                ? `SuccessTrayId: ${beforeHash} | FailedTrayId: ${afterHash}`
                : `FailedTrayId: ${afterHash}`
            }`
          );
        }
      }
      // toast.error(
      //   `${
      //     beforeHash.length === 0 && afterHash.length === 0
      //       ? formatMessage('could_not_connect_to_AIMS_server')
      //       : formatMessage(assignTagState.error)
      //   } - ${
      //     beforeHash.length > 0
      //       ? `SuccessTrayId: ${beforeHash} | FailedTrayId: ${afterHash}`
      //       : `FailedTrayId: ${afterHash}`
      //   }`
      // formatMessage(
      //   `${assignTagState.error} ${
      //     beforeHash.length > 0
      //       ? `SuccessTrayId: ${beforeHash} | FailedTrayId: ${afterHash}`
      //       : `FailedTrayId: ${afterHash}`
      //   }`
      // )
      // );
      resetAssignTagState();
    }
  }, [assignTagState.error]);

  useEffect(() => {
    if (removeTagState.error) {
      const [beforeHash, afterHash] = responseData.split('#');
      toast.error(
        formatMessage(
          `${removeTagState.error} ${
            beforeHash.length > 0
              ? `SuccessTrayId: ${beforeHash} | FailedTrayId: ${afterHash}`
              : `FailedTrayId: ${afterHash}`
          }`
        )
      );

      resetRemoveTagState();
    }
  }, [removeTagState.error]);

  useEffect(() => {
    if (assignTagState.success) {
      toast.success(formatMessage('added_success'));
      setFilterObj({ ...PartsSearchFilterInitialState });
      resetAssignTagState();
      getFilteredTraysListServiceHandler();
    }
  }, [assignTagState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.TrayId && row.TrayId === selectedRow.TrayId) {
      className = 'bg-row SelectedRow assign-tags';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    // GetProcessByIdService(row.Id);
    setSelectedRow(row);
    setSelectedId(row.TrayId);
    // setSelectedId(row.Id);
    // if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
    //   setOpenPanel(true);
    // } else {
    //   setOpenPanel(!openPanel);
    // }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const handleTableChange = (type: any, newState: any) => {
    if (
      newState.sortField !== columSortOrder.dataField ||
      newState.sortOrder !== columSortOrder.order
    ) {
      const updatedFilter = {
        ...filterObj,
        Column: newState.sortField,
        Order: newState.sortOrder,
      };

      setColumnSortOrder({
        ...columSortOrder,
        dataField: newState.sortField,
        order: newState.sortOrder,
      });
      setFilterObj(updatedFilter);
      localStorage.setItem('filter', JSON.stringify(updatedFilter));
      GetPartsSearchResultsService(
        Number(getTenantIdFromLocalStorage()),
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        [],
        selected.map((option) => option.value === '' ? ' ' : option.value),
        true,
        updatedFilter,
        groups
      );
    }
  };

  const onPageChanged = (pageNumber: number) => {
    closePanelHandler();
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    const selectedPageLimit = parseInt(evt.target.value);
    const totalRecords = PartsSearchList?.PagingDetails?.TotalRecords ?? 0;
    const pages =
      totalRecords > 0 ? Math.ceil(totalRecords / selectedPageLimit) : 1;
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: selectedPageLimit,
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, selectedPageLimit);
  };

  const dimensionColumn = allDimensionHeaders.map(
    (dimension: string, index: number) => {
      return {
        dataField: dimension,
        text: formatMessage(dimension),
        classes: 'wrap-data',
        formatter: (cell, row, rowIndex) => {
          return (
            <>
              {cell ? (
                <span className="dimension-class show-Elipses">
                  {cell.slice(0, 30)}
                </span>
              ) : (
                '-'
              )}
              {cell && cell?.length > 30 && (
                <>
                  ...
                  <OverlayTrigger
                    overlay={
                      <Tooltip id={`tray-tooltip-${rowIndex}`}>{cell}</Tooltip>
                    }
                  >
                    <span className="info-svg text-muted">
                      <InfoCircle
                        className="text-muted"
                        size={14}
                      />
                    </span>
                  </OverlayTrigger>
                </>
              )}
            </>
          );
        },

        // events: {
        //   onClick: (e) => {
        //     e.stopPropagation();
        //   },
        // },
      };
    }
  );

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: rows
      .filter((row) => selectedIds.includes(row.TrayId))
      .map((row) => row.RowKey),
    // nonSelectable: [...nonSelectableIds],
    selectionRenderer: ({ mode, checked, disabled }: any) => (
      <input
        type={mode}
        checked={checked}
        disabled={disabled}
        className="form-check-input"
        readOnly
      />
    ),
    selectionHeaderRenderer: ({ checked, indeterminate }: any) => (
      <input
        type="checkbox"
        checked={checked}
        ref={(input: HTMLInputElement | null) => {
          if (input) input.indeterminate = indeterminate;
        }}
        className="form-check-input"
        readOnly
      />
    ),
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelectedIds((prev) => Array.from(new Set([...prev, row.TrayId])));
      } else {
        setSelectedIds((prev) =>
          prev.filter((TrayId) => TrayId !== row.TrayId)
        );
      }
    },

    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const allIds = Array.from(new Set(rows.map((row) => row.TrayId)));
        setSelectedIds(allIds);
      } else {
        setSelectedIds([]);
      }
    },
  };

  const openLEDHandler = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    props.addToggleHandler();
    // resetTrayDetail();
  };

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },
    {
      dataField: 'TrayId',
      text: formatMessage('tray_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ProductId',
      text: formatMessage('product_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'Kishu',
      text: formatMessage('kishu'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'DeliveryDate',
      text: formatMessage('customer_due_date'),
      sort: true,
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    ...dimensionColumn,
  ];

  useEffect(() => {
    if (rows.length === 0) {
      setSelectedId('');
    }
  }, [rows]);

  const handleSelectionChange = async (selectedOptions) => {
    const normalizedFilter = getFilterObjectFromLocation();
    const activeFilter = {
      ...normalizedFilter,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    };

    if (selectedOptions.length === 0) {
      setSelected([]);
    } else {
      setSelected(selectedOptions);
      localStorage.setItem(
        'materialKatashiki',
        JSON.stringify(selectedOptions)
      );
    }
    setRows([]);
    setSelectedRow({});
    setSelectedId('');
    setFilterObj(activeFilter);
    localStorage.setItem('filter', JSON.stringify(activeFilter));
    GetPartsSearchResultsService(
      Number(getTenantIdFromLocalStorage()),
      pageInfo.currentPage,
      pageLimitInfo.pageLimit,
      [],
      selectedOptions.map((option) => option.value === '' ? ' ' : option.value),
      true,
      activeFilter,
      groups
    );
  };

  const handleColumnSelectionChange = async (selectedOptions) => {
    if (selectedOptions.length === 0) {
      setSelectedDimensions([]);
      setAllowedColumns([
        // ...initialSelection.map((item) => item.value),
        // 'checkbox',
      ]);
    } else {
      setSelectedDimensions(selectedOptions);
      setAllowedColumns([
        ...selectedOptions.map((item) => item.value),
        'checkbox',
      ]);
    }

    SaveProcessOrderService({
      SettingKey: userSettingEnum.PartsSearch,
      ProcessOrder: selectedOptions.map((opt) => opt.value).join(','),
    });
  };

  const filteredColumns = columns.filter((col: any) =>
    allowedColumns.includes(col.dataField)
  );

  useEffect(() => {
    if (saveProcessOrderState.success) {
      // toast.success(formatMessage('updated_success'));
      setRows([]);
      getFilteredTraysListServiceHandler();
      resetSaveProcessOrderState();
    }
  }, [saveProcessOrderState.success]);

  useEffect(() => {
    if (ledBlinkState.success) {
      toast.success(formatMessage('added_success'));
      resetGetOrderTableListServiceState();
      resetLedBlinkState();
      // setSelectedIds([]);
    }
  }, [ledBlinkState.success]);

  useEffect(() => {
    if (ledBlinkState.error) {
      toast.error(formatMessage(ledBlinkState.error));
      resetLedBlinkState();
      // setSelectedIds([]);
    }
  }, [ledBlinkState.error]);

  return (
    <>
      <div className={`operator-wrapper ${fontSizeClass}`}>
        {props.showLEDBlinkPopup && (
          <LEDBlink
            id={0}
            modalClosed={props.addToggleHandler}
            selectedRows={selectedIds.map((row) => row)}
          />
        )}

        <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
          <div className="row align-items-center">
            <Header
              className="col"
              label="parts_search"
              bomState={localStorage.getItem('filter')}
              // route='/DIDInnovateHub/BomSearch'
            />

            <div className="col-lg-7 col-md-6 col-sm-6">
              <div className="pe-4 d-flex justify-content-end">
                <>
                  <MultiSelect
                    className="mx-2 traySearchBom"
                    //  isOpen={true}
                    options={dimensionColumnFields.map((field) => ({
                      ...field,
                      label: formatMessage(field.label),
                    }))}
                    // options={dimensionColumnFields}
                    value={selectedDimensions}
                    onChange={handleColumnSelectionChange}
                    labelledBy="Select"
                    // className={`multiselect-react produsct-select ${allTrayListData.length === 0 ? 'div-disabled' : ''}`}
                    valueRenderer={() => formatMessage('select_columns')}
                    overrideStrings={{
                      selectAll: formatMessage('select_all_options'),
                      search: formatMessage('search'),
                    }}
                  />
                  <MultiSelect
                    className="mx-2 filterSearchBom"
                    options={orderViewColumnFields}
                    value={selected}
                    onChange={handleSelectionChange}
                    //  isOpen={true}
                    labelledBy="Select"
                    // className={`multiselect-react produsct-select ${allTrayListData.length === 0 ? 'div-disabled' : ''}`}
                    valueRenderer={() => (
                      <>
                        <FilterIcon />
                      </>
                    )}
                    overrideStrings={{
                      selectAll: formatMessage('select_all_options'),
                      search: formatMessage('search'),
                    }}
                  />
                  {isOperationPermittedRoleBase(
                    ModuleType.OrderViewDashboard,
                    'Add'
                  ) && (
                    <li
                      title={formatMessage('led_title')}
                      className="process-chart"
                    >
                      <a
                        className={`btn btn-secondary ${
                          selectedIds.length === 0
                            ? // || selectedIds.length > MAX_RECORDS_LENGTH
                              'disabled'
                            : ''
                        }`}
                        data-toggle="modal"
                        data-testid="modalbtn"
                        data-target="#addUser"
                        onClick={(event: any) => openLEDHandler(event)}
                      >
                        <FormattedMessage id="led_title" />
                      </a>
                    </li>
                  )}
                </>
              </div>
            </div>
          </div>
        </div>
        <div className={`${openPanel ? 'panelOpen' : ''}`}>
          <div className="card card-page">
            {(getPartsSearchResultsServiceState.inProgress ||
              ledBlinkState.inProgress) && (
              <FormLoader
                loading={
                  getPartsSearchResultsServiceState.inProgress ||
                  ledBlinkState.inProgress
                }
              />
            )}

            <div>
              {allowedColumns.length > 0 && filteredColumns.length > 0 ? (
                <>
                  <div className="opertor-dummy part-search-table">
                    <div className="tableDesign row-eq-height tableDevices p-3">
                      <div
                        className="table-responsive"
                        data-testid="table"
                      >
                        {filteredColumns && filteredColumns.length > 0 && (
                          <Grid
                            data={rows}
                            columns={filteredColumns}
                            keyField="RowKey"
                            loading={false}
                            rowClasses={rowClassFormat}
                            rowEvents={{ onClick: rowEvents }}
                            hover={true}
                            sort={{ ...columSortOrder }}
                            remote={{ sort: true }}
                            onTableChange={handleTableChange}
                            selectRow={selectRow}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {rows.length > 0 ? (
                    <div className="row no-gutters p-3 pt-0 tableFooter">
                      <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                        <FormattedMessage id="show" />
                        <select
                          data-testid="pageSelect"
                          className="pageLimit"
                          onChange={onPageLimitChanged}
                          value={pageLimitInfo.pageLimit}
                        >
                          {pageLimitOptions.map((op: any) => (
                            <option
                              key={op}
                              value={op}
                            >
                              {op}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-lg-9 col-md-6 col-sm-6 d-flex align-items-center justify-content-sm-end">
                        <p className="me-3 mb-0">
                          {`${formatMessage('selectedItems')} ${selectedIds.length}`}
                        </p>
                        <Pagination
                          isRefreshPage={false}
                          totalPages={pageInfo.totalPages}
                          pageLimit={pageLimitInfo.pageLimit}
                          onPageChanged={onPageChanged}
                          disablePagination={disablePagination}
                          setIsRefreshPage={setIsRefreshPage}
                          currentPage={pageInfo.currentPage}
                          totalRecords={
                            PartsSearchList?.PagingDetails?.TotalRecords
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </>
              ) : (
                <div className="message">
                  <div className="d-flex message-area">
                    <div className="no-data-img">
                      <img
                        src={noMessageIcon}
                        alt=""
                        className="no_message"
                      />
                    </div>
                    <div>
                      <h3 className="fw-bold display-6">
                        {' '}
                        {/* <FormattedMessage id= "no_record" /> */}
                        <FormattedMessage
                          id={
                            orderViewColumnFields.length > 0
                              ? 'no_column_selected'
                              : 'no_record'
                          }
                        />
                      </h3>
                      {/* <h4 className="mb-3">
                        {formatMessage('no_record_message')}
                      </h4> */}
                      {/* {isOperationPermittedRoleBase(
                          ModuleType.ProcessManagement,
                          'Add'
                        ) && (
                          <LoaderButton
                            text="add_process"
                            onClick={(event: any) =>
                              openAddProcessHandler({ Id: -1 }, event)
                            }
                          />
                        )} */}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LEDBlinkPopupHOC(
  FilterPopupHOC(DeletePopupHOC(observer(PartsSearch)))
);
